import type { ButtonProps } from '@mui/material/Button';

import { useCallback } from 'react';

import Button from '@mui/material/Button';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  onClose?: () => void;
};

export function SignOutButton({ onClose, sx, ...other }: Props) {
  // const router = useRouter();

  const { t } = useTranslate('translation');

  const handleLogout = useCallback(async () => {
    onClose?.();
  }, [onClose]);

  return (
    <Button
      fullWidth
      size="large"
      color="error"
      onClick={handleLogout}
      sx={{
        width: '90%',
        margin: '0 auto',
        justifyContent: 'left',
        '&:hover': {
          backgroundColor: 'inherit',
        },
      }}
      {...other}
    >
      {t('LOGOUT')}
    </Button>
  );
}
